<template>
	<div>
		<h2 class="clearfix mb-4">
			{{$t('edit')}}
			<div class="float-right" v-if="ready">
                <button v-if="placementprovider.id" class="btn btn-dark mr-2" @click="downloadPlacementReport()">{{ $t("placement-report") }}</button>
                <button 
                    v-if="placementprovider.id"
                    type="button" 
                    class="btn btn-secondary mr-2" 
                    @click="$router.push(`/timetables/placements?provider_id=${placementprovider.id}`)"
                >
                    {{ $t('view-timetable') }}
                </button>
				<button @click="savePlacement()" class="btn btn-primary" :disabled="!placementprovider.title">{{ $t('save') }}</button>
			</div>
		</h2>

		<div v-if="saved" class="alert alert-success">{{$t('saved')}}</div>
		<div class="row mb-4">
			<div class="col-12 col-xl-12">
				<template v-if="ready">
					<TextInput
						:label="$t('title')"
						v-model="placementprovider.title"
					/>

					<TextAreaAutosize
						:label="$t('notes')"
						v-model="placementprovider.note"
						class="mb-4"
					/>

					<b-tabs pills v-model="tabIndex" content-class="mb-4 pt-2">
						<b-tab>
							<template #title>
								{{$t('users')}}
								<span class="badge rounded-pill bg-secondary text-white" v-if="placementprovider.users.length">{{placementprovider.users.length}}</span>
							</template>
							<UserSelector
								v-model="placementprovider.users"
								:loading="!ready"
								:users="users"
								displayKey="displayname"

							/>
						</b-tab>
						<b-tab>
							<template #title>
								{{$t('rooms')}}
								<span class="badge rounded-pill bg-secondary text-white" v-if="placementprovider.ttrooms.length">{{placementprovider.ttrooms.length}}</span>
							</template>
							<RoomSelector
								v-model="placementprovider.ttrooms"
								:loading="!ready"
								:rooms="rooms"
								displayKey="name"
							/>
						</b-tab>
					</b-tabs>
				</template>
				<div v-else>
                    <div class="skeleton midnight h32 w-50 rounded mb-3"></div>
					<div class="skeleton midnight h32 w-100 rounded mb-3"></div>
					<div class="skeleton midnight h32 w-100 rounded mb-3"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import UserSelector from "src/components/Users/UserSelector";
import RoomSelector from "src/components/Rooms/RoomSelector";

export default {
	components: {
        UserSelector,
        RoomSelector
	},
    data() {
        return {
            ready: false,
            saved: false,
        	total: 0 ,
            filters: {
                page: 1,
                page_size: 30,
                search: '',
                sort: '',
                order: '',
            },
            placementprovider: {
                id: '',
                title: '',
                note: '',
                users:[],
                ttrooms:[]
            },
            stage:{},
            tabIndex:0,
            users:[],
            rooms:[]
        }

    },
    created(){
        this.getUsers();
        this.getRooms();
    },
    mounted() {
        if (this.isNew) {
			this.ready = true;
		} else {
			this.getProvider(this.$route.params["placementprovider_id"]);
		}
    },
    methods:{
        getProvider(id){
            this.placementprovider.id = id;
            return this.$cfetch(`${this.$settings.APIBaseURL}/placementprovider/get`,{
                method: "post",
                data:{
                    id: id
                }
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    this.placementprovider=res.result;
					// this.placementprovider.ttrooms= this.displayRooms(this.placementprovider.ttrooms);
            		this.ready = true;
                	this.filters.page = res.pagination.page
                	this.filters.page_size = res.pagination.page_size
                	this.total = res.pagination.total
				} else {
					this.$log.info.call(this, status)
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
        },
        getUsers() {
            this.$cfetch(`${this.$settings.APIBaseURL}/getusers`,
                {
                    method: "post",
                    data: {
                        priv: 'PLACEMENT_MY_PLACEMENTS'
                    }
                }
            )
            .then(res => {
                if (res.status == "SUCCESS") {
                	this.users = res.users.map(user => {
                        return {
                            ...user,
                            displayname: user.displayName
                        }
                    });
                }
            })
            .catch(error => {
                this.$log.error.call(this, error);
            });
		},
        displayName(user){
            return user.displayName;
        },
        getRooms () {
			this.$cfetch(`${this.$settings.APIBaseURL}/timetable/ttroom/listall`).then(
                (res) => {
                    if (res.status === "SUCCESS") {
                        this.rooms = res.results;
                    } else {
					this.$log.info.call(this, status)
				    }
                })
            .catch(error => {
                this.$log.error.call(this, error);
            });
		},
        savePlacement(){
            this.saved=false;
            this.$store.commit("showBlockingSpinner");
            this.$cfetch(`${this.$settings.APIBaseURL}/placementprovider/save`,{
                method: "post",
                data: this.placementprovider
            })
            .then((res) => {
                this.$store.commit("hideBlockingSpinner");
                if (res.status === "SUCCESS") {
                    this.placementprovider.id = res.result.id;
                	this.saved=true;
                } else {
                	this.$log.info.call(this, status)
                }
                })
            .catch(error => {
                this.$log.error.call(this, error);
            });
        },
		downloadPlacementReport() {
			let body = {
				username: this.$UserSession.getValue.call(this, "username"),
				authToken: this.$UserSession.getValue.call(this, "authToken"),
				download: 1,
                provider_id: this.placementprovider.id
			};

			const url = `${this.$settings.APIBaseURL}/placements/myplacements?` + new URLSearchParams(body).toString();
			window.open(url);
		}
    },
    computed: {
		isNew: function () {
			return this.$route.params["placementprovider_id"] == 'add';
		},
	},
}
</script>
